window.addEventListener('load', () => {

    /************ Bootstrap Tooltip *************/
    $("body").tooltip({ selector: '[data-toggle=tooltip]' });

    /*** Slider - Price range configuration ***/
    $(".vs-slider-primary button").on('click', (e) => {
        e.preventDefault();
    });


    /*** Validate price inputs ***/
    $("#areaMinValue, #areaMaxValue").keypress((event) => {
      return /^\d*\.?\d*$/.test(String.fromCharCode(event.keyCode || event.which));
    });


    /*** Toastr Config ***/
    toastr.options.progressBar = false;
    toastr.options.showMethod = 'slideDown';
    toastr.options.hideMethod = 'slideUp';
    // toastr.options.timeOut = 300;
    // toastr.options.extendedTimeOut = 90;

    toastr.options.timeOut = 200;
    toastr.options.extendedTimeOut = 90;
    toastr.options = {
        "preventDuplicates": true,
        "preventOpenDuplicates": true
    };



    /******* AOS Animation - Config ********/
    const AOS = require('aos/dist/aos.js');
    AOS.init({
        duration: 1000,
    });
    /******* ********************* ********/

    /******* Select2 Config ********/
    $('.js-example-basic-single').select2();
    $('.intro .select-custom').select2({
        minimumResultsForSearch: -1
    });
    /******* ********************* ********/


    /******* Scroll to Top Config ********/
    const header = $('.header'),
        backToTopBtn = $('.back-to-top');

    $(window).on('scroll', function() {
        let scroll = $(window).scrollTop();
        if (scroll > 0) {
            header.addClass('scrolled');
        } else if (scroll === 0) {
            header.removeClass('scrolled');
        }

        if (scroll > 400) {
            backToTopBtn.addClass('show')
        } else {
            backToTopBtn.removeClass('show')
        }
    });

    backToTopBtn.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 700);
    });
    /******* ********************** ********/


    /******** Custom Placeholder ********/
    const inputField = $('#register-form .form-control');
    inputField.on('input', function () {
        if ($(this).val().length) {
            $(this).prev().hide();
        } else {
            $(this).prev().show();
        }
    });
    /******* ********************** ********/


    /*** ****** Ease Scroll ****** ***/
    /***** Home Page only *****/
    $("body").easeScroll({
        frameRate: 60,
        animationTime: 1350,
        stepSize: 130,
        accelerationMax: 5,
       // keyboardSupport: true,
        // arrowScroll: 50,
        // touchpadSupport: true,
        // fixedBackground: true
    });

    /*** FancyBox - Config ***/
    $('.property-view-fancybox').fancybox({
        buttons: [
            "close"
        ],
    });
});
